import React from 'react';
import PropTypes from 'prop-types';

/**
 * Component for highlighting matched text within a string
 *
 * @param {Object} props Component props
 * @param {string} props.text The text to display with highlighting
 * @param {string} props.highlight The search term to highlight within the text
 * @returns {JSX.Element} Rendered component with highlighted text
 */
const HighlightedText = ({ text, highlight }) => {
  if (!highlight.trim()) {
    return <span>{text}</span>;
  }

  const parts = text.split(new RegExp(`(${highlight})`, 'gi'));

  return (
    <span>
      {parts.map((part, i) => {
        const isHighlighted = part.toLowerCase() === highlight.toLowerCase();
        const uniqueKey = `${text}-${part}-${i}`;

        return isHighlighted ? (
          <span key={uniqueKey} style={{ backgroundColor: '#fff3b5' }}>
            {part}
          </span>
        ) : (
          <span key={uniqueKey}>{part}</span>
        );
      })}
    </span>
  );
};

HighlightedText.propTypes = {
  text: PropTypes.string.isRequired,
  highlight: PropTypes.string.isRequired,
};

export default HighlightedText;
